import type { LightboxSrcData } from './types';

export function computeLightboxUrl(src: string): string {
    return src.replace(/\.([^.]+)$/, '_lightbox.$1');
}

export function getActiveSourceFromPicture(imgElement: HTMLElement): string | null {
    const picture = imgElement.closest('picture');

    if (!picture) {
        return null;
    }

    const sources = picture.querySelectorAll('source');

    for (let i = 0; i < sources.length; i++) {
        const source = sources[i];
        const media = source.getAttribute('media');
        const srcset = source.getAttribute('srcset');

        if (media && srcset && window.matchMedia(media).matches) {
            return srcset;
        }
    }

    return null;
}

export function getLightboxSrcData(element: HTMLElement): LightboxSrcData | string | null {
    if (element.hasAttribute('data-lightbox-src')) {
        return element.getAttribute('data-lightbox-src');
    }

    const activeSource = getActiveSourceFromPicture(element);
    const src = activeSource || (element as HTMLImageElement).src || element.getAttribute('src');

    if (!src) {
        return null;
    }

    return {
        lightbox: computeLightboxUrl(src),
        original: src
    };
}

export function loadImageWithFallback(srcData: LightboxSrcData | string): Promise<string> {
    return new Promise((resolve) => {
        if (typeof srcData === 'string') {
            resolve(srcData);
            return;
        }

        const img = new Image();
        img.onload = () => resolve(srcData.lightbox);
        img.onerror = () => resolve(srcData.original);
        img.src = srcData.lightbox;
    });
}
